/* Fabareeze conversion callout. Cart drawer: quantity nudge + always-on BANK TRANSFER TOTAL line. PDP #fbQtyNudge shows the single cart-appropriate block, and ALWAYS resets to the default 2nd-suit nudge when the cart is empty (never leaves a stale bank total). 2026-07-24 audit: third-suit tier line removed (never advertise tiers above Rs 400); duplicate COD footnote removed (bank line already carries the nudge). Observer watches the stable <cart-drawer> wrapper so it survives Dawn's drawer re-renders.
   2026-08-06: PDP copy split from drawer copy. On a PRODUCT page the bare 'Bank transfer total — Rs X' printed the CART total, which read as a wrong price for the product on screen (owner caught Rs 6,600 under a Rs 7,250 suit). The PDP now says 'Your cart by bank transfer' + the piece count; the DRAWER keeps the short label because inside the cart the context is obvious. This JS is the copy of record for #fbQtyNudge — it overwrites the Liquid-rendered branch in fb-pdp-trust.liquid on every cart change, so keep the two in sync. */
(function(){
  var DEFAULT_PDP={lead:'Add a second suit — Extra Rs 400 off', sub:'Any design, applied automatically at checkout.'};
  function money(paise){ return 'Rs '+Math.round(paise/100).toLocaleString('en-PK'); }
  function qtyMsg(q){
    if(q===1) return {lead:'Add a second suit — Extra Rs 400 off', sub:'Any design, applied automatically at checkout.'};
    return null;
  }
  function bankMsgPdp(c){
    if(c.total_price<=0) return null;
    return {lead:'Your cart by bank transfer — '+money(c.total_price), sub:'Total for the '+c.item_count+' pieces already in your cart — bank transfer skips the 4% COD tax.'};
  }
  function bankMsg(c){
    if(c.total_price<=0) return null;
    return {lead:'Bank transfer total — '+money(c.total_price), sub:'Skip the 4% government COD tax. Account details shown at checkout.'};
  }
  function setPdp(el, m){
    var key=m.lead+'|'+m.sub;
    if(el.getAttribute('data-m')===key) return;
    el.setAttribute('data-m', key);
    el.innerHTML='';
    var a=document.createElement('span'); a.className='fb-conv__lead'; a.textContent=m.lead;
    var b=document.createElement('span'); b.className='fb-conv__sub'; b.textContent=m.sub;
    el.appendChild(a); el.appendChild(b);
  }
  function setCart(n, parts){
    var key=parts.map(function(p){return p.lead;}).join('|');
    if(n.getAttribute('data-m')===key) return;
    n.setAttribute('data-m', key);
    n.innerHTML='';
    parts.forEach(function(p){
      var b=document.createElement('span'); b.className='fb-cnudge__b';
      var a=document.createElement('span'); a.className='fb-cnudge__lead'; a.textContent=p.lead;
      var s=document.createElement('span'); s.className='fb-cnudge__sub'; s.textContent=p.sub;
      b.appendChild(a); b.appendChild(s); n.appendChild(b);
    });
  }
  var busy=false, pending=false;
  function refresh(){
    if(busy){ pending=true; return; }
    busy=true; pending=false;
    fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json();}).then(function(c){
      busy=false;
      var q=c.item_count;
      var p=document.getElementById('fbQtyNudge');
      if(p){ setPdp(p, qtyMsg(q)||bankMsgPdp(c)||DEFAULT_PDP); }
      var f=document.querySelector('#CartDrawer .drawer__footer')||document.getElementById('main-cart-footer');
      if(f){
        var n=f.querySelector('.fb-cnudge');
        if(q<=0){ if(n){n.remove();} }
        else {
          var parts=[]; var qm=qtyMsg(q); if(qm)parts.push(qm); var bm=bankMsg(c); if(bm)parts.push(bm);
          if(!parts.length){ if(n){n.remove();} }
          else { if(!n){ n=document.createElement('div'); n.className='fb-cnudge'; f.insertBefore(n, f.firstChild); } setCart(n, parts); }
        }
      }
      if(pending) refresh();
    }).catch(function(){ busy=false; if(pending) refresh(); });
  }
  var t=null; function sched(){ clearTimeout(t); t=setTimeout(refresh,160); }
  function start(){
    var roots=[document.querySelector('cart-drawer'), document.getElementById('CartDrawer'), document.getElementById('main-cart-items'), document.getElementById('main-cart-footer')].filter(Boolean);
    roots.forEach(function(rt){ try{ new MutationObserver(sched).observe(rt,{childList:true,subtree:true}); }catch(e){} });
    if(typeof subscribe==='function' && typeof PUB_SUB_EVENTS!=='undefined' && PUB_SUB_EVENTS.cartUpdate){ try{ subscribe(PUB_SUB_EVENTS.cartUpdate, sched); }catch(e){} }
    document.addEventListener('cart:refresh', sched);
    sched();
  }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', start); } else { start(); }
})();
